var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminExpiredDocuments(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-180 -1494) translate(180 1494)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.629 17.119H2.139A2.14 2.14 0 0 1 0 14.98L.012 2.139A2.136 2.136 0 0 1 2.139 0h6.424L10.7 2.139h8.56a2.142 2.142 0 0 1 2.14 2.14v4.069a6.422 6.422 0 0 0-8.771 8.77z",
    transform: "translate(-180 -1494) translate(-755.191 293.062) translate(936 1203.999)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.013 3A4.587 4.587 0 0 0 2.5 7.66H1l1.949 2.014.035.072L5.009 7.66h-1.5a3.565 3.565 0 0 1 3.504-3.624 3.565 3.565 0 0 1 3.508 3.624 3.565 3.565 0 0 1-3.508 3.624 3.425 3.425 0 0 1-2.475-1.067l-.712.735a4.416 4.416 0 0 0 3.187 1.368 4.587 4.587 0 0 0 4.51-4.66A4.587 4.587 0 0 0 7.013 3zm-.5 2.589v2.589l2.144 1.315.361-.626-1.754-1.078v-2.2z",
    transform: "translate(-180 -1494) translate(-755.191 293.062) translate(947.858 1212.56) translate(-1 -3)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminExpiredDocuments);
export default __webpack_public_path__ + "static/media/admin-expired-documents.60f7d74325eee031d7ba14a7009fb563.svg";
export { ForwardRef as ReactComponent };